import { IconListView } from '@xingternal/icons';
import {
  fixTripleClickSelection,
  isBlockActive,
  toggleBlock,
  UNORDERED_LIST_DEFINITIONS,
} from '@xingternal/content-editor-plugin-helpers';

const buttonConfig = ({
  disabledForBlockTypes = [],
  icon = IconListView,
  label = 'Unordered List',
  ...props
} = {}) => ({
  isDisabled: (editor) =>
    disabledForBlockTypes.some((element) => isBlockActive(editor, element)),
  isHighlighted: (editor) =>
    isBlockActive(editor, UNORDERED_LIST_DEFINITIONS.type),
  icon,
  label,
  onClick: (event, editor) => {
    event.preventDefault();
    fixTripleClickSelection(editor);
    toggleBlock(editor, UNORDERED_LIST_DEFINITIONS.type);
  },
  ...props,
});

export { buttonConfig };
